import React from "react";
import { Typography } from "@mui/material";
import { accordionDetailsClasses } from "@mui/material";

import { MzAccordion, MzAccordionSummary, MzAccordionDetails } from "@markaaz/ui/MzAccordionControls";
import DecisioningRow from "./DecisioningRow";

const sx = {
  accordion: {
    [`.${accordionDetailsClasses.root}`]: {
      padding: 0
    },
    maxWidth: "860px"
  },
  accordionSummary: {
    paddingLeft: "20px"
  }
};

export default function DecisioningSection({ label, items, values, onRadioChange, onCheckboxChange, onSliderChange }) {
  const [expanded, setExpanded] = React.useState(true);

  function handleAccordionChange(_, newExpanded) {
    setExpanded(newExpanded);
  }

  return (
    <MzAccordion sx={sx.accordion} expanded={expanded} onChange={handleAccordionChange}>
      <MzAccordionSummary sx={sx.accordionSummary}>
        <Typography variant="body1B">{label}</Typography>
      </MzAccordionSummary>
      <MzAccordionDetails>
        {items.map((item) => {
          return (
            <DecisioningRow
              key={item.label}
              rowData={item}
              values={values}
              onRadioChange={onRadioChange(item)}
              onCheckboxChange={onCheckboxChange(item)}
              onSliderChange={onSliderChange(item)}
            />
          );
        })}
      </MzAccordionDetails>
    </MzAccordion>
  );
}
